import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { EmbersStatusIcon } from '../../../statusIcon';
import { PROMETHEAN_FOCUS_SHADOW, PROMETHEAN_SECONDARY_BLUE_MID } from '../../../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersAccessibleIcon';
var iconStyle = {
  cursor: 'pointer',
  '&:focus-visible': {
    boxShadow: PROMETHEAN_FOCUS_SHADOW + ' inset',
    height: 'fit-content'
  }
};
export var StyledSimpleIcon = styled('i')(_objectSpread({}, iconStyle));
export var StyledStatusIcon = styled(EmbersStatusIcon, {
  shouldForwardProp: function shouldForwardProp(propName) {
    return !(propName === 'isTooltip');
  }
})(function (_ref) {
  var isTooltip = _ref.isTooltip;
  return _objectSpread({
    i: _objectSpread({}, iconStyle),
    '&.EmbersAccessibleIcon-icon-only': _objectSpread(_objectSpread({}, iconStyle), {}, {
      '&.EmbersAccessibleIcon-info': {
        '&.EmbersStatusIcon-icon': {
          color: PROMETHEAN_SECONDARY_BLUE_MID
        }
      }
    }),
    '&.EmbersAccessibleIcon-info': {
      '.EmbersStatusIcon-icon': {
        color: PROMETHEAN_SECONDARY_BLUE_MID
      }
    }
  }, isTooltip && {
    '&.EmbersStatusIcon': {
      '.EmbersStatusIcon-icon': {
        display: 'none'
      },
      '.EmbersStatusIcon-text': {
        marginLeft: 0,
        cursor: 'text'
      }
    }
  });
});